import React from 'react';
import banner from '../../assets/slider4.jpg';
import banner1 from '../../assets/slider1.jpg';
import banner2 from '../../assets/slider2.jpg';
import banner3 from '../../assets/replace-slider.jpg';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';

const ImageSlider = () => {
  const sliderSettings = {
    dots: true,
    autoplay: true,
    infinite: true,
    speed: 550,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplaySpeed: 2500,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };

  return (
    <div className='lg:mt-[170px] mt-[120px] w-full'>
      <Slider {...sliderSettings}>
        <div className="w-full">
          <img 
            src={banner} 
            alt="Slider-Image" 
            className="w-full h-auto object-cover"
          />
        </div>
        <div className="w-full">
          <img 
            src={banner1} 
            alt="Slider-Image" 
            className="w-full h-auto object-cover"
          />
        </div>
        <div className="w-full">
          <img 
            src={banner2} 
            alt="Slider-Image" 
            className="w-full h-auto object-cover"
          />
        </div>
        <div className="w-full">
          <img 
            src={banner3} 
            alt="Slider-Image" 
            className="w-full h-auto object-cover"
          />
        </div>
      </Slider>
    </div>
  );
};

export default ImageSlider;